document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.angela_audio_player').forEach(function (player) {
        const audio = player.querySelector('audio');
        const playBtn = player.querySelector('.angela_audio_controls_actions_play');
        const pauseBtn = player.querySelector('.angela_audio_controls_actions_pause');
        const currentTimeEl = player.querySelector('.angela_audio_controls_time_current');
        const totalTimeEl = player.querySelector('.angela_audio_controls_time_total');
        const progressContainer = player.querySelector('.angela_audio_progress');
        const progressBar = player.querySelector('.angela_audio_progress_bar');
        const volumeContainer = player.querySelector('.angela_audio_controls_secondary_volume');
        const volumeBar = player.querySelector('.angela_audio_controls_secondary_volume_bar');
        const downloadBtn = player.querySelector('.angela_audio_controls_secondary_download');

        let lastVolume = audio.volume;

        function formatTime(seconds) {
            const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
            const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
            return `${mins}:${secs}`;
        }

        function updateProgress() {
            if (!isNaN(audio.duration)) {
                const percent = (audio.currentTime / audio.duration) * 100;
                progressBar.style.width = percent + '%';
                currentTimeEl.textContent = formatTime(audio.currentTime);
            }
        }

        function setDuration() {
            if (!isNaN(audio.duration)) {
                totalTimeEl.textContent = formatTime(audio.duration);
            }
        }

        function updatePlayerState() {
            player.setAttribute('data-state', audio.paused ? 'pause' : 'play');
        }

        function updateVolumeBar() {
            const vol = (audio.muted ? 0 : audio.volume) * 100;
            volumeBar.style.width = vol + '%';

            if (audio.muted || audio.volume === 0) {
                volumeContainer.classList.add('muted');
            } else {
                volumeContainer.classList.remove('muted');
            }
        }

        // Play / Pause
        playBtn.addEventListener('click', () => audio.play());
        pauseBtn.addEventListener('click', () => audio.pause());

        // Volume clic gauche
        volumeContainer.addEventListener('click', function (e) {
            const rect = volumeContainer.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            const newVolume = clickX / rect.width;
            audio.muted = false;
            audio.volume = Math.max(0, Math.min(1, newVolume));
            updateVolumeBar();
        });

        // Volume clic droit : mute/unmute
        volumeContainer.addEventListener('contextmenu', function (e) {
            e.preventDefault();
            if (audio.muted || audio.volume === 0) {
                audio.muted = false;
                audio.volume = lastVolume > 0 ? lastVolume : 0.5;
            } else {
                audio.muted = true;
                lastVolume = audio.volume;
                audio.volume = 0;
            }
            updateVolumeBar();
        });

        // Barre de progression clic
        progressContainer.addEventListener('click', function (e) {
            const rect = this.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            const newTime = (clickX / rect.width) * audio.duration;
            audio.currentTime = newTime;
        });

        // Bouton download
        downloadBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const url = this.getAttribute('href');
            const a = document.createElement('a');
            a.href = url;
            a.download = url.split('/').pop();
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        });

        // Événements audio
        audio.addEventListener('play', updatePlayerState);
        audio.addEventListener('pause', updatePlayerState);
        audio.addEventListener('timeupdate', updateProgress);
        audio.addEventListener('loadedmetadata', () => {
            setDuration();
            updateVolumeBar();
        });

        // Initialisation
        updatePlayerState();
        updateVolumeBar();
        setDuration();
    });
});
